export default "__VITE_ASSET__956644ff__"